import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Initialize CSP utilities
import '@/utils/csp'

import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import { env } from './config/env'

if (env.enableDebugLogging) {
  console.debug('🚀 App Starting - Debug Info:')
  console.debug(
    '  React StrictMode:',
    typeof StrictMode !== 'undefined' ? 'loaded' : 'undefined',
  )
  console.debug(
    '  ReactDOM createRoot:',
    typeof createRoot !== 'undefined' ? 'loaded' : 'undefined',
  )
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>,
) 